/* eslint-disable */
/* @flow */

import React, { Component } from 'react'
import { Text, TextInput, View } from 'react-native'

import Cell from './Cell'


import styles from './Styles/InputCellStyles'

class InputCell extends Component {

  render() {
    const {
      meta: { touched, error, warning, field }, input: { name, value, onBlur, onChange, ...restInput },
      autoCapitalize,
      autoCorrect,
      keyboardType = 'default',
      newValue = "",
      placeholder,
      secure,
      separator,
      title,
      editable = true

    } = this.props


    return (
      <Cell separator={separator} >
        <View style={styles.container}>
          <Text style={styles.title}>{title}</Text>
          <TextInput
            onBlur={onBlur}
            {...restInput}
            editable={editable}
            autoCapitalize={autoCapitalize}
            autoCorrect={autoCorrect}
            keyboardType={keyboardType}
            onChangeText={onChange}
            placeholder={placeholder}
            placeholderTextColor={styles.color}
            secureTextEntry={secure}
            style={styles.textInput}
            value={name === "username" ? newValue : value}
          />

        </View>
        {touched && ((error && <Text style={styles.error}>{error}</Text>) ||
          (warning && <Text style={styles.warning}>{warning}</Text>))}
      </Cell>
    )
  }
}


//make this component available to the app


export default InputCell
